module.exports = __webpack_public_path__ + "static/media/Notice Grey.1a1b5a9b.svg";